export default __webpack_public_path__ + "static/media/logo.aca8f25f.svg";